import { HttpClient } from '@angular/common/http';
import { ApplicationRef, inject, Injectable, LOCALE_ID } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';

import { environment, Teacher, TeacherDetail, TeacherProfile } from 'src/index';
import { AuthenticationService, capitalize, convertPrefixedByIdObjects, CoursesService, LoadingService, PopupService, RoutingService, SearchService } from 'src/index/services.index';

@Injectable({
  providedIn: 'root'
})
export class TeachersService {
  authService = inject(AuthenticationService);
  routingService = inject(RoutingService);
  popupService = inject(PopupService);
  applicationRef = inject(ApplicationRef);
  loadingService = inject(LoadingService);
  httpClient = inject(HttpClient);
  searchService = inject(SearchService);
  coursesService = inject(CoursesService);

  locale = inject(LOCALE_ID);

  convertTeachers(teachers: string[]): Partial<Teacher>[] {
    return convertPrefixedByIdObjects(teachers).map(({ id, data }) => ({ id, fullname: data } as Partial<Teacher>));
  }

  getTeacher(teacherId: string): Observable<Teacher | undefined> {
    if (environment.teacherDetail) {
      return this.httpClient.get<TeacherProfile>(environment.teacherDetail.replace(':id', teacherId)).pipe(
        map(teacherProfile => {
          const { id, fullname, email, profiles, ...details } = teacherProfile.teacher;
          const teacher: Teacher = {
            id,
            fullname,
            email,
            profiles,
            details: Object.keys(details).reduce((data, detailKey) => ([
              ...data,
              {
                label: capitalize(detailKey),
                value: details[detailKey],
                type: 'string', // TODO: identify links and emails
              },
            ]), [] as TeacherDetail[]),
            titularCourses: teacherProfile.titularCourses?.map(course => this.coursesService.convertPackageCourse(course)),
            supportCourses: teacherProfile.supportCourses?.map(course => this.coursesService.convertPackageCourse(course)),
          }
          return teacher;
        }),
        catchError(() => of(undefined)),
      );
    }
    return of(undefined);
  }
}

